import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {  getAdminModule,  addAdminModule,  updateAdminModule,  deleteAdminModule} from "../../redux/actions/adminModule.action";
import { getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getLog } from "../../redux/actions/log.action";
import { getRights } from "../../redux/actions/userRights.action";
import PageHeader from "../../components/PageHeader/PageHeader";
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables";
import { ReadCookie } from "../../utils/readCookie";
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Divider } from "antd";
import { logColumns, adminModuleColumns } from "../../utils/cols";
import notification from "../../utils/notification";
import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";

const { TabPane } = Tabs;

export default function AdminModule({ token }) {
  TabTitle("Admin Module")
  const menuId = ReadCookie("menuId");
  const dCompanyId = ReadCookie("defaultCompany");
  const adminModuleNameInput = useRef(null);
  const [form] = Form.useForm();
  const [adminModuleObj, setAdminModuleObj] = useState(null);
  const dispatch = useDispatch();
  const { adminModule, log, userRights } = useSelector((state) => state);
  const [minimize, setMinimize] = useState(false);
  const [check, setCheck] = useState(false);
  const [adminModuleName, setAdminModuleName] = useState("");
  const [disable, setDisable] = useState(false);
  const [formState, setFormState] = useState("view");

  useEffect(() => {
    dispatch(getAdminModule(token, menuId));
    dispatch(getLog(token, { admin_module: "admin_module" }));
  }, [token]);

  useLayoutEffect(() => {
    dispatch(getRights(token, menuId)).then((res) => {
      if (res.type === "GET_USER_RIGHTS_SUCCESS") {
        if (!res?.payload.can_add) {
          setFormState("table");
        }
      }
    });
  }, []);

  useEffect(() => {
    if (adminModuleObj) {
      setFormState("view");
      form.setFieldsValue({
        id: adminModuleObj.module_id,
        adminModule: adminModuleObj.module_name,
        active: adminModuleObj.is_active,
      });
      setAdminModuleName(adminModuleObj.module_name);
      setCheck(adminModuleObj.is_active);
    }
  }, [adminModuleObj]);

  useEffect(() => {
    if (adminModuleName === "") {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [adminModuleName]);


  const formSave = () => {
    if (formState === "add") {
      dispatch(addAdminModule(token, { adminModuleName, check }, menuId)).then(
        (res) => {
          if (res.type === "ADD_ADMIN_MODULE_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          if (res.type === "ADD_ADMIN_MODULE_SUCCESS") {
            notification(
              "success",
              "Admin Module created",
              "Admin Module created successfully!"
            );
            form.setFieldsValue({
              adminModule: "",
            });
            setFormState("");
            // setCheck(false)
            setAdminModuleName("");
            setAdminModuleObj(null);
          }
          dispatch(getAdminModule(token, menuId));
        }
      );
    }

    if (formState === "edit") {
      dispatch(
        updateAdminModule(
          token,
          { adminModuleName, check },
          adminModuleObj.module_id
        )
      ).then((res) => {
        if (res.type === "UPDATE_ADMIN_MODULE_ERROR") {
          notification("error", "Update", "Something went wrong");
        }
        if (res.type === "UPDATE_ADMIN_MODULE_SUCCESS") {
          notification(
            "success",
            "Admin Module update",
            "Record updated successfully"
          );
        }
        dispatch(getAdminModule(token, menuId));
      });
    }
  };

  const handleDelete = () => {
    if (adminModuleObj) {
      dispatch(deleteAdminModule(token, adminModuleObj.module_id)).then(
        (res) => {
          if (res.type === "DELETE_ADMIN_MODULE_SUCCESS") {
            notification(
              "success",
              "Admin Module deleted",
              "Admin Module deleted successfully!"
            );
          }
          if (res.type === "DELETE_ADMIN_MODULE_ERROR") {
            notification(
              "error",
              res?.payload?.request?.statusText,
              res?.payload?.data?.data
            );
          }
          form.setFieldsValue({
            adminModule: "",
          });
          // setCheck(false)
          setAdminModuleName("");
          setAdminModuleObj(null);
          setFormState("");
          dispatch(getAdminModule(token, menuId));
        }
      );
    }
  };

  useEffect(() => {
    if (formState === "add") {
      dispatch(getOneDefaultCompany(token, dCompanyId));
      adminModuleNameInput.current.focus();
      form.setFieldsValue({
        adminModule: "",
      });
      setCheck(true);
      setAdminModuleName("");
      setAdminModuleObj(null);
    }
  }, [formState]);

  const filterReset = () => {
    setFormState("view");
  };

  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"AdminModule"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="crudDiv">
              <CrudButtons
                rights={userRights?.payload}
                reset={filterReset}
                formType={formState}
                save={formSave}
                disable={disable}
                formState={setFormState}
                onDelete={handleDelete}
              />
            </div>

            <div className="styleContent">
              <Row className="tables-main-row-new">
                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                  <div className="styleTable">
                    <Tables
                      type="adminModule"
                      adminModuleObj={setAdminModuleObj}
                      scrollX={"20rem"}
                      scroll={602}
                      perPage={25}
                      source={adminModule?.payload?.data}
                      col={adminModuleColumns}
                      paginate
                      load={adminModule.loading}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                  <div className="styleForm">
                    <Form form={form} name="basic" labelCol={{ span: 8 }}>
                      <div className="customRow styleFormUpper ">
                        {adminModuleObj !== null && !(formState === "add") && (
                          <div className="customCols slc">
                            <Form.Item
                              label="ID"
                              labelCol={{ span: 10 }}
                              wrapperCol={{ span: 14 }}
                              name="id"
                              initialValue={form.getFieldValue().id}
                            >
                              <Input
                                className="styleInput id-field-style"
                                readOnly
                              />
                            </Form.Item>
                          </div>
                        )}
                        <div className="customCols slc">
                          <Form.Item
                            label="Admin Module"
                            name="adminModule"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                            initialValue={form.getFieldValue().adminModule}
                          >
                            <Input
                              size="small"
                              // placeholder="Admin Module Name"
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              ref={adminModuleNameInput}
                              onChange={(e) =>
                                setAdminModuleName(e.target.value)
                              }
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                        <div className="customCols slc">
                          <Form.Item
                            label="Active"
                            name="active"
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <Checkbox
                              disabled={
                                !(formState === "add" || formState === "edit")
                              }
                              checked={check}
                              onChange={(e) => setCheck(e.target.checked)}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Form>

                    <Divider />
                    <div className="styleTab">
                      <Tabs
                        type="card"
                        tabBarGutter={2}
                        defaultActiveKey="1"
                        centered
                      >
                        <TabPane tab="Log Info" key="1">
                          <div className="tabs">
                            <Tables
                              type="company"
                              scrollX={"50rem"}
                              scroll={360}
                              perPage={15}
                              source={log?.payload?.data}
                              col={logColumns}
                              load={log.loading}
                              paginate
                            />
                          </div>
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
      {minimize && (
        <div className="styleFooter">
          <Button
            className="minimize-button-style"
            onClick={() => setMinimize(false)}
          >
            Style
          </Button>
        </div>
      )}
    </div>
  );
}
